import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { Label2 } from '@components/typography/interVariants';
import { themeMediaQuery } from '@utils/styledTheme.util';
import styled from 'styled-components';

export const StyledCardWrapper = styled(Box)`
  .text-pairing-title {
    max-width: 75%;
  }
  ${themeMediaQuery('md')} {
    .text-pairing-title {
      max-width: 346px;
    }
  }
`;

export const ProgressLabel = styled(Text)`
  ${Label2};
  color: ${(props) => props.theme.colors.white};
`;
